import { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = UnknownError | HttpBadStatusCodeError;

export type QueryKey = [EQueryKeys.AbUse__V1_GetMultipleExperiment];

export const getQueryKey = (): QueryKey => [EQueryKeys.AbUse__V1_GetMultipleExperiment];
